import { useEffect } from 'react';

import Bugsnag from '@bugsnag/js';
import { useSupabaseAuth } from '@hooks/useSupabaseAuth';

/**
 * This component just sets the user for the bugsnag error handler
 */
export const UserErrorHandler = () => {
  const { user } = useSupabaseAuth();

  useEffect(() => {
    // Set user ID for Bugsnag when it changes
    if (user) {
      Bugsnag.setUser(user.id);
    } else {
      Bugsnag.setUser(null);
    }
  }, [user]);

  return null;
};
